import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';

export const paginationStyle = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    color: '#515f75',
  },
}));

const getCorrectUtc = (completeUtc) => {
  const defaultValue = '-03:00';

  try {
    const temp = completeUtc.split(')')[0].split('GMT')[1].split('');

    if (temp.length === 5) {
      temp.splice(1, 0, '0');
    }

    if (temp.length !== 6) {
      return defaultValue;
    }

    return temp.join('');
  } catch (error) {
    return defaultValue;
  }
};

export const formatDate = ({ startDate, endDate, timezone }) => {
  return {
    start_date: startDate
      ? moment(startDate)
          .utcOffset(getCorrectUtc(timezone.fuso), true)
          .format('YYYY-MM-DD HH:mm')
      : null,
    end_date: endDate
      ? moment(endDate)
          .utcOffset(getCorrectUtc(timezone.fuso), true)
          .format('YYYY-MM-DD HH:mm')
      : null,
  };
};
